import { request } from '@umijs/max';

const API_BASE = '/api';

export async function adminLogin(data: { mobile: string; password: string }) {
  return request<API.ApiResponse<{ token: string; user: API.CurrentUser }>>(
    `${API_BASE}/auth/v1/admin-login`,
    { method: 'POST', data },
  );
}

export async function adminSMSLogin(data: { mobile: string; sms_code: string }) {
  return request<API.ApiResponse<{ token: string; user: API.CurrentUser }>>(
    `${API_BASE}/auth/v1/admin-sms-login`,
    { method: 'POST', data },
  );
}

export async function sendSMS(data: { mobile: string; tpl_id: number; type?: string }) {
  return request<API.ApiResponse<any>>(`${API_BASE}/auth/v1/send-sms-by-tpl-id`, {
    method: 'POST',
    data,
  });
}

export async function adminLogout() {
  return request<API.ApiResponse>(`${API_BASE}/auth/v1/admin-logout`, { method: 'GET' });
}

export async function getCurrentUser() {
  return request<API.ApiResponse<API.CurrentUser>>(`${API_BASE}/backend/v1/current-user`, {
    method: 'GET',
  });
}

export async function checkLogin() {
  return request<API.ApiResponse<{ is_login: boolean; user?: API.CurrentUser }>>(
    `${API_BASE}/open/v1/check-login`,
    { method: 'GET' },
  );
}

export async function getDashboardStats() {
  return request<API.ApiResponse<API.DashboardStats>>(
    `${API_BASE}/backend/v1/dashboard-statistics`,
    { method: 'GET' },
  );
}
